import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { EmailValidator } from "@atenea-cms";
import { Department } from "./department.model";
import { Person } from "./person.model";

@Injectable()
export class DepartmentFormService {
  constructor(private fb: FormBuilder) {}

  getForm(department: Department = new Department()): FormGroup {
    return this.fb.group({
      _id: [department._id],
      name: [department.name, Validators.required],
      active: [department.active],
      requestProduct: [department.requestProduct],
      persons: this.fb.array(
        department.persons.map((item) => this.getPersonForm(item))
      ),
    });
  }

  getPersonForm(person: Person = new Person()): FormGroup {
    return this.fb.group({
      _id: [person._id],
      name: [person.name, Validators.required],
      email: [person.email, [Validators.required, EmailValidator]],
      active: [person.active],
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/shared/department-form.service.ts